import { editors } from "@/mocks/posts";

export default function EditorPanel() {
  return (
    <div className="rounded-lg border border-background-200/70 bg-background-50 p-4 md:p-5">
      <h3 className="flex items-center gap-2 font-heading text-base font-bold text-foreground-950 mb-3">
        <i className="ri-award-line text-accent-600" aria-hidden="true"></i>
        编辑部推荐
      </h3>
      <ul className="space-y-4">
        {editors.map((editor) => (
          <li key={editor.name} className="flex items-center gap-3">
            <div className="h-11 w-11 shrink-0 overflow-hidden rounded-full">
              <img
                src={editor.avatar}
                alt={`${editor.name}头像`}
                className="h-full w-full object-cover object-top"
              />
            </div>
            <div className="min-w-0">
              <p className="text-sm font-semibold text-foreground-950">{editor.name}</p>
              <p className="text-xs text-foreground-500">{editor.role}</p>
            </div>
          </li>
        ))}
      </ul>
      <div className="mt-5 rounded-md bg-accent-100 p-3 text-xs leading-relaxed text-accent-900">
        有猛料想分享？点右下角「我要爆料」，优质线索将由编辑部跟进核实。
      </div>
    </div>
  );
}